import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-215094fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "scan-trailer-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CameraBegging = _resolveComponent("CameraBegging")!
  const _component_fbx_qr_scanner = _resolveComponent("fbx-qr-scanner")!
  const _component_ManualAttachCard = _resolveComponent("ManualAttachCard")!
  const _component_SvgXMark = _resolveComponent("SvgXMark")!
  const _component_InvalidQRConfirmation = _resolveComponent("InvalidQRConfirmation")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.cameraBeggingEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_CameraBegging, {
            onOnContinueClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCameraBegging = false))
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_fbx_qr_scanner, {
            paused: _ctx.isCameraPaused,
            onScanned: _ctx.onScanned,
            onScanError: _ctx.onScannerError,
            onScannerReady: _ctx.onScannerReady
          }, null, 8, ["paused", "onScanned", "onScanError", "onScannerReady"]),
          _createVNode(_component_ManualAttachCard, {
            text: "Having trouble scanning?",
            disabled: !_ctx.actionsEnabled,
            onOnManualAttach: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onManualAttach')))
          }, null, 8, ["disabled"]),
          (_ctx.actionsEnabled)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "scan-trailer-x",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onCloseScanner')))
              }, [
                _createVNode(_component_SvgXMark)
              ]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.displayInvalidQrOverlay)
      ? (_openBlock(), _createBlock(_component_InvalidQRConfirmation, {
          key: 2,
          onClose: _ctx.closeConfirmationModal
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}